import { useEducationalEventsContext } from './educational-events-context';
import { EventsSidebar } from './components/events-sidebar/events-sidebar';
import { EventDetailPanel } from './components/event-detail-panel/event-detail-panel';
import { NotFound } from 'src/components/common';
import styles from './educational-events.module.scss';

export function EducationalEventsLayout() {
  const { error } = useEducationalEventsContext();

  if (error) {
    return (
      <div className={styles.layoutError}>
        <NotFound />
      </div>
    );
  }

  return (
    <div className={styles.layout}>
      <EventsSidebar />
      <EventDetailPanel />
    </div>
  );
}
